import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { feelingById, type FeelingId } from '../constants/bridge';

const DAYS = 30;
const dayKey = (iso: string) => new Date(iso).toDateString();

/** One stone per task finished in the last month, coloured by the sky the patient picked that day. */
export function useRiverStones(userId?: string | null, refreshKey = 0) {
  const [stones, setStones] = useState<(FeelingId | null)[]>([]);

  useEffect(() => {
    if (!userId) return;
    let alive = true;
    const from = new Date(Date.now() - DAYS * 864e5).toISOString();
    Promise.all([
      supabase.from('xp_history').select('created_at').eq('user_id', userId).gte('created_at', from).order('created_at', { ascending: true }),
      supabase.from('mood_logs').select('created_at, mood_type').eq('user_id', userId).gte('created_at', from).order('created_at', { ascending: true }),
    ]).then(([xp, mood]: { data: { created_at: string; mood_type?: string }[] | null }[]) => {
      if (!alive) return;
      const skyOfDay = new Map<string, FeelingId>();
      for (const m of mood.data ?? []) {
        const f = feelingById(m.mood_type);
        if (f) skyOfDay.set(dayKey(m.created_at), f.id);
      }
      setStones((xp.data ?? []).map((r) => skyOfDay.get(dayKey(r.created_at)) ?? null));
    });
    return () => { alive = false; };
  }, [userId, refreshKey]);

  return stones;
}
